// Failure reports carry text only. Photo custody stays with the existing draft.
const invalid = () => { throw new Error('Saved failure report needs review; nothing was sent.'); };
export function copyDeliveryFailureAttempt(value) {
  if (!value || value.version !== 1 || value.kind !== 'failure'
      || typeof value.captureId !== 'string' || !/^[A-Za-z0-9_-]{1,128}$/.test(value.captureId)
      || !['ready', 'pending', 'unknown', 'rejected', 'accepted'].includes(value.status)
      || !['nobody_home', 'wrong_address', 'other'].includes(value.fields?.reason)
      || typeof value.fields.details !== 'string') invalid();
  return Object.freeze({ version: 1, kind: 'failure', captureId: value.captureId, status: value.status,
    fields: Object.freeze({ reason: value.fields.reason, details: value.fields.details.trim() }) });
}

export const createDeliveryFailureAttempt = (fields) => copyDeliveryFailureAttempt({
  version: 1, kind: 'failure', captureId: crypto.randomUUID(), status: 'ready',
  fields: { reason: fields.failureReason, details: fields.failureDetails || '' },
});

export function buildIdentifiedFailure(value) {
  const attempt = copyDeliveryFailureAttempt(value);
  return { failure_id: attempt.captureId, failure_version: 1, ...attempt.fields };
}

export function readDeliveryFailureReceipt(value, orderId, result) {
  const attempt = copyDeliveryFailureAttempt(value);
  if (result?.version !== 1 || result.order_id !== orderId || result.capture_id !== attempt.captureId) invalid();
  if (result.failure === null) return 'not-found';
  const receipt = result.failure; const failure = receipt?.result?.failure;
  if (!receipt || receipt.version !== 1 || receipt.capture_id !== attempt.captureId || receipt.phase !== 'failure'
      || typeof receipt.accepted_at !== 'string' || !Number.isFinite(Date.parse(receipt.accepted_at))
      || receipt.result?.order_id !== orderId || receipt.result.status !== 'failed'
      || failure?.reason !== attempt.fields.reason || failure?.details !== attempt.fields.details) invalid();
  return 'accepted';
}
